// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadingTitle_wrapper__NM+Cs","loading":"LoadingTitle_loading__uotxU"};